import { Box, Paper, Typography, Accordion, AccordionSummary, AccordionDetails, CircularProgress } from '@mui/material';
import { useParams } from 'react-router-dom';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useChat } from '../hooks/useChat';
import { useEffect } from 'react';
import { analytics } from '../services/analytics';
import { useAnalytics } from '../hooks/useAnalytics';
import { useAuth } from '../contexts/AuthContext';

function HomeAreas() {
  const { homeId } = useParams<{ homeId: string }>();
  const { areas, isLoading, refreshMessages } = useChat();
  const { user } = useAuth();

  useEffect(() => {
    if (homeId !== undefined && refreshMessages !== undefined) {
      refreshMessages();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [homeId]);

  // Log areas_list_open analytics event
  useAnalytics(
    () => {
      if (user?.uuid && homeId) {
        analytics.logAreasListOpen(user.uuid, homeId, areas.length);
      }
    },
    [homeId, user?.uuid, areas.length]
  );

  return (
    <Box sx={{ 
      flex: 1,
      minHeight: 0,
      display: 'flex',
      flexDirection: 'column',
      height: '100%'
    }}>
      <Paper sx={{ 
        flex: 1, 
        display: 'flex',
        flexDirection: 'column',
        overflow: 'auto',
        m: 3,
        p: 3 
      }}>
        <Typography variant="h6" gutterBottom sx={{ px: 2 }}>
          Areas Discussed
        </Typography>

        {isLoading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flex: 1 }}>
            <CircularProgress />
          </Box>
        ) : areas.length === 0 ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flex: 1 }}>
            <Typography color="text.secondary">No areas discussed yet</Typography>
          </Box>
        ) : (
          <Box sx={{ mt: 2 }}>
            {areas.map((area, index) => (
              <Accordion key={index}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls={`area-${index}-content`}
                  id={`area-${index}-header`}
                  onClick={() => {
                    if (user?.uuid && homeId) {
                      const areaName = typeof area === 'object' ? area.area_name : String(area);
                      analytics.logAreaDetailOpen(user.uuid, areaName, homeId);
                    }
                  }}
                >
                  <Typography>{typeof area === 'object' ? area.area_name : String(area)}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography color="text.secondary">
                    Details about this area will be available soon.
                  </Typography>
                </AccordionDetails>
              </Accordion>
            ))}
          </Box>
        )}
      </Paper>
    </Box>
  );
}

export default HomeAreas;